/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Dining_RoomInputs */

const cs_enum_dining_room = /** @type {(inputs: Enum_Dining_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jídelna`)
};

const en_enum_dining_room = /** @type {(inputs: Enum_Dining_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dining room`)
};

/**
* | output |
* | --- |
* | "Dining room" |
*
* @param {Enum_Dining_RoomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_dining_room = /** @type {((inputs?: Enum_Dining_RoomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Dining_RoomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_dining_room(inputs)
	return cs_enum_dining_room(inputs)
});